// Data for the Hotels & Lodges landing page
// Target: luxury hotels, lodges, resorts, hospitality groups

export const HOTELS_CLIENTS = [
  { name: "Sun International", region: "Mauritius (all properties)" },
  { name: "Mauritius Airlines", region: "Mauritius" },
  { name: "Accor", region: "International" },
  { name: "Pullman Hotels & Resorts", region: "International" },
  { name: "K-Hotel", region: "Cameroon" },
  { name: "Hotel Cardoso", region: "Mozambique" },
  { name: "Four Seasons", region: "International" },
  { name: "IHG Hotels & Resorts", region: "International" },
  { name: "Westmon Hotels", region: "Kenya" },
  { name: "Crowne Plaza", region: "Tanzania" },
  { name: "Cunard", region: "Cruise" },
  { name: "Crystal Cruises", region: "Cruise" },
  { name: "Lanzerac", region: "South Africa" },
  { name: "World Luxury Hotel Awards", region: "Award Partner" },
];

// Curated hospitality / luxury / food / lifestyle work shown on the Hotels landing page.
// Sourced from the Pie in the Sky Productions portfolio (YouTube reel library).
export const HOSPITALITY_PORTFOLIO = [
  { youtubeId: "KEwcH03tdpA", title: "Luxury Property Film", category: "Hotel & Resort", tag: "Cinematic" },
  { youtubeId: "EzqyKm7tWmU", title: "Suite & Stay Experience", category: "Hotel & Resort", tag: "Lifestyle" },
  { youtubeId: "bzukc6okzho", title: "Signature Dining", category: "Food & Beverage", tag: "Culinary" },
  { youtubeId: "6-rXuBnDCa4", title: "Destination Lifestyle Reel", category: "Lifestyle", tag: "Travel" },
  { youtubeId: "iNAhiKMGF18", title: "Hospitality Brand Story", category: "Brand Film", tag: "Storytelling" },
  { youtubeId: "I_iJtr8HZd4", title: "Resort Cinematic Cutdown", category: "Hotel & Resort", tag: "Social" },
  { youtubeId: "i2pbkWLkeq4", title: "Culinary Experience", category: "Food & Beverage", tag: "Editorial" },
  { youtubeId: "-Mv183AYffg", title: "Luxury Stay Showcase", category: "Hotel & Resort", tag: "Property" },
  { youtubeId: "5RQ7uHeC7Vw", title: "Boutique Lifestyle Film", category: "Lifestyle", tag: "Brand" },
];

export const VISIBILITY_ENGINE_FEATURES = [
  { icon: "Search", title: "SEO Content Strategy", desc: "Keyword research and on-page SEO across your property, room types, dining and experiences." },
  { icon: "MapPin", title: "Destination Content Planning", desc: "Topic clusters around your location, region, and travel intent - so you rank for what guests actually search." },
  { icon: "FileText", title: "Travel-Focused Blog Strategy", desc: "Long-form content that builds authority, captures Google + AI search traffic, and feeds direct bookings." },
  { icon: "LayoutGrid", title: "Location Landing Pages", desc: "High-intent pages built around region, season, and traveler segments (couples, families, leisure, MICE)." },
  { icon: "Film", title: "Experience-Focused Content", desc: "Cinematic films and photography of the moments guests actually book - sunsets, food, suites, signature experiences." },
  { icon: "Sparkles", title: "AI Search Optimization", desc: "Content structured for ChatGPT, Perplexity, Google AI Overviews - where travelers are increasingly searching first." },
  { icon: "BadgeCheck", title: "Google Business Profile Optimization", desc: "Photos, posts, reviews, Q&A - the GBP work that drives discovery in Maps and Local Pack." },
  { icon: "Globe2", title: "Local SEO", desc: "Map pack rankings, citation building, and review velocity strategy for your destination." },
  { icon: "ArrowRightLeft", title: "Direct Booking Funnels", desc: "Content that captures search demand and channels travelers to your direct booking page - lower OTA dependence." },
  { icon: "Target", title: "Search Intent Mapping", desc: "We map every traveler search query to a content asset - from inspiration to consideration to booking." },
  { icon: "Network", title: "Content Cluster Strategy", desc: "Topic clusters and internal linking that build topical authority around your destination and brand." },
  { icon: "TrendingUp", title: "Authority & Backlink Building", desc: "Travel media partnerships, influencer integrations, and digital PR that earn authoritative backlinks." },
];

export const HOTEL_OFFER_TIERS = [
  {
    id: "destination-essentials",
    name: "Destination Essentials",
    priceFrom: "R28,000",
    period: "/month",
    minimum: "3-month minimum",
    headline: "Monthly cinematic + photography refresh.",
    blurb: "Steady visual content for hospitality brands ready to invest in monthly social, OTA listings and digital marketing assets.",
    features: [
      "1 cinematic property film (60-90s) per quarter",
      "20 social cutdowns per month (vertical + landscape)",
      "Monthly photography refresh - rooms, F&B, lifestyle",
      "Edit + colour + sound in-house",
      "Multi-platform asset delivery",
    ],
    addon: false,
    featured: false,
  },
  {
    id: "destination-authority",
    name: "Destination Authority System™",
    priceFrom: "R48,000",
    period: "/month",
    minimum: "3-month minimum · most popular",
    headline: "Cinematic content + strategic content marketing.",
    blurb: "Visual storytelling combined with a content marketing engine that drives discoverability and direct bookings.",
    features: [
      "Everything in Destination Essentials",
      "Quarterly brand film production day on-property",
      "Monthly content marketing strategy session",
      "Destination content planning + topic clusters",
      "Blog & landing-page content recommendations",
      "Google Business Profile optimization",
      "Quarterly performance reporting",
    ],
    addon: false,
    featured: true,
    badge: "Most popular",
  },
  {
    id: "hospitality-seo-partner",
    name: "Hospitality SEO Growth Partner",
    priceFrom: "R22,000",
    period: "/month",
    minimum: "Add-on · 6-month minimum",
    headline: "The strategy + AI search layer for ambitious hotels.",
    blurb: "An add-on to either tier (or stand-alone for properties with existing content libraries). Full content-led SEO and AI search visibility partnership.",
    features: [
      "SEO strategy & quarterly roadmap",
      "AI Search Optimization (ChatGPT, Perplexity, Google AI Overviews)",
      "Monthly content planning calendar",
      "Blog content recommendations & briefs",
      "Landing-page recommendations & UX audit",
      "Monthly search performance reporting",
      "Direct-booking growth strategy",
      "Backlink & authority building campaigns",
    ],
    addon: true,
    featured: false,
    badge: "Add-on",
  },
];

export const HOTEL_FAQS = [
  { q: "Who delivers the SEO and content marketing work?", a: "Our sister marketing agency, Optima Growth Agency (optimagrowth.agency), delivers the strategic SEO, AI search optimization and content marketing layer. You get one unified team, one strategy, and one invoice - we just bring deeper specialist firepower to the SEO side via our marketing division." },
  { q: "Do you travel internationally for hotel productions?", a: "Yes - frequently. We've shot for Sun International across their Mauritius properties (plus Mauritius Airlines), K-Hotel (Cameroon), Hotel Cardoso (Mozambique), Westmon Hotels (Kenya), Crowne Plaza (Tanzania), plus extensive work across South Africa for Lanzerac and other luxury properties. Cape Town crew + cinema kit can fly to any destination." },
  { q: "How is travel billed?", a: "Transparently. Cape Town & Western Cape shoots include travel in the day rate. Rest of South Africa, flights and accommodation are billed at cost as a line item. International productions (Mauritius, Mozambique, Cameroon, Kenya, Tanzania, etc.) get a full travel + accommodation + per-diem quote upfront as a separate line item - so you know every Rand before we book." },
  { q: "Do you offer discounted shoots when you're already travelling in the region?", a: "Yes - this is one of our most popular options. We travel internationally 8-12 times a year. When we're already in your region for another production, we offer one-off shoots at significantly reduced travel cost. Drop us your dates and destination and we'll let you know if we'll be in the area." },
  { q: "What's the difference between Destination Essentials and Destination Authority System™?", a: "Essentials is pure cinematic content production - films, photography, social cutdowns. Authority System adds strategic content marketing on top: SEO content planning, destination authority building, GBP optimization. Authority System helps content actually drive bookings, not just sit on Instagram." },
  { q: "Do we own the content?", a: "Yes - full rights transfer on delivery. Raw rushes archived for 12 months, available on request. You can use everything across OTA listings, web, paid social, brochures, PR - in perpetuity." },
  { q: "Can we white-label or co-credit with our brand team?", a: "Yes. We work behind-the-scenes for many international brands and agencies. Credit can be private or shared - your call." },
  { q: "What if our property already has a marketing agency?", a: "We work alongside agencies regularly. We focus on what most agencies can't deliver in-house: cinema-grade production + AI/SEO content strategy. We're additive, not territorial." },
  { q: "How quickly do we see results from the Hospitality SEO Growth Partner add-on?", a: "Realistic timeline: first AI search wins within 30-60 days (structured content surfaces fast on Perplexity / ChatGPT), Google ranking improvements typically 90-180 days. Direct booking lift compounds over 6-12 months. We report monthly with clear metrics." },
  { q: "Can you handle multi-property hotel groups?", a: "Yes - we've worked with Accor, Pullman, IHG and Sun Life across multiple territories. Group discounts apply from 3+ properties. Each property gets its own content calendar and reporting view." },
];

export const HOTEL_HERO_IMAGE = "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=2400&q=80&auto=format&fit=crop";
